'use client';
/* Built In Imports */
// import NextLink from 'next/link';

import { useEffect, useState } from 'react';

/* External Imports */
import { Link } from '@chakra-ui/next-js';
import {
  Box,
  Center,
  Image,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import CalendarTabs from '@app-ps/Components/Tabs/CalendarTabs';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import config from '@config';
import { useSearchParams } from 'next/navigation';

/* Services */

/**
 * Renders the Performance Calender component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Performance Calender component
 */
const Calendar = ({ sectionContent, region, lang }) => {
  const searchParams = useSearchParams();
  const [selTab, setSelTab] = useState(0);
  const [catType, setCatType] = useState('');
  const [isOnline, setIsOnline] = useState(null);
  const [isFree, setIsFree] = useState(null);
  const tabColors = ['#60ADFF', '#F18128', '#EDA807'];
  const tabName = ['all', 'productions', 'workshops'];

  useEffect(() => {
    // console.log('catType', catType, tabName);
    const ind = tabName.indexOf(catType?.toLowerCase());
    setSelTab(catType ? ind : 0);
  }, [catType]);

  useEffect(() => {
    setCatType(searchParams.get('type')?.toLowerCase());
    setIsOnline(
      searchParams.get('isonline') === null ? '' : searchParams.get('isonline')
    );
    setIsFree(
      searchParams.get('isfree') === null ? '' : searchParams.get('isfree')
    );
  }, [searchParams]);

  const handleTabsChange = index => {
    // console.log('handleTabsChange', index)
    setSelTab(index);
  };
  // console.log(
  //   searchParams.toString(),
  //   searchParams.get('isonline'),
  //   'online',
  //   searchParams.get('type'),
  //   'type',
  //   searchParams.get('isfree'),
  //   'free',
  //   'params'
  // );
  return (
    <Box
      background="#010509"
      w="100%"
      px="1rem"
      paddingBottom={{ base: '5rem', lg: '12rem' }}
    >
      <Center
        my={{ base: '40px', md: '80px' }}
        marginX={{ base: '4.5rem', md: '10rem' }}
      >
        <Image
          src={`${config.imgPath}/d/46272/1722934894-vector.svg`}
          width="auto"
          height="auto"
          opacity={'0.6'}
        />
      </Center>
      <Tabs
        isLazy
        align="center"
        colorScheme="blue.800"
        index={selTab}
        onChange={handleTabsChange}
      >
        <TabList border="none" gap={{ '2xl': '2rem' }}>
          {Object.keys(sectionContent.allProductionWorkshopTextLabel.json).map(
            (tab, index) => (
              <Tab
                key={index}
                _selected={{
                  color: tabColors[index],
                  borderColor: tabColors[index],
                }}
                fontSize={{ base: '1rem', md: '28px' }}
                fontFamily="var(--FedraSerifDisplay-Bold)"
                color="#F1EDE9"
                opacity={{ base: '80%' }}
                _focus={{ boxShadow: 'none' }}
                textTransform="uppercase"
                padding="0"
                margin="0 15px"
                borderColor="#F1EDE9"
                _hover={{
                  color: tabColors[index],
                }}
                scroll={false}
              >
                <Link
                  href={refineUrlDomain(
                    `/calendar?type=${tab.toLowerCase()}&isonline=${
                      isOnline !== '1' ? '' : '1'
                    }&isfree=${isFree !== '1' ? '' : '1'}`,
                    region,
                    lang
                  )}
                  scroll={false}
                  // legacyBehavior
                  key={index}
                  _hover={{ boxShadow: 'none' }}
                  _focus={{ boxShadow: 'none' }}
                  prefetch
                >
                  {tab}
                </Link>
              </Tab>
            )
          )}
        </TabList>
        <TabPanels>
          {Object.keys(sectionContent.allProductionWorkshopTextLabel.json).map(
            tab => (
              <TabPanel
                maxW={1100}
                w="100%"
                mx="auto"
                p={{ base: '30px 0 0', md: '100px 0 0', '2xl': '10rem 0 0' }}
              >
                <CalendarTabs
                  catType={catType}
                  sectionContent={sectionContent}
                  isProduction={tab.toLowerCase() === 'production'}
                  selTab={selTab}
                  id={sectionContent.allProductionWorkshopTextLabel.json[tab]}
                  region={region}
                  lang={lang}
                />
              </TabPanel>
            )
          )}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Calendar;
